import React from 'preact/compat';
import { useFormikContext } from 'formik';
import { useSelfServiceFormContext } from './context';

export default function Submit() {
    const { isSubmitting } = useFormikContext();
    const {
        classNames: {
            button: classNames,
        },
    } = useSelfServiceFormContext();

    return (
        <div className='form__footer'>
            <button type='submit' disabled={isSubmitting} className={classNames.submit}>
                Submit
            </button>
        </div>
    );
}
